import { createContext } from 'react';
import { CartTotalDetails, emptyCartTotalDetails } from '@kouto/cart-prices';
import {
  ConfirmCardPaymentCallback,
  SubmitCardPaymentCallback,
} from 'features/ShoppingCart/types';
import { Stripe } from '@stripe/stripe-js';

type PaymentContextType = CartTotalDetails & {
  /** True while a continuous item's price is still unknown, so the cart total is not yet meaningful. */
  isQuotePending?: boolean;
  confirmCardPaymentCallback?: ConfirmCardPaymentCallback | null;
  getPaymentIntentInfoCallback?: Stripe['retrievePaymentIntent'] | null;
  setPaymentIntentInfoCallback?: (
    callback: () => Stripe['retrievePaymentIntent'],
  ) => void;
  setConfirmCardPaymentCallback?: (
    callback: ConfirmCardPaymentCallback,
  ) => void;
  submitCardPaymentCallback?: SubmitCardPaymentCallback | null;
  setSubmitCardPaymentCallback?: (callback: SubmitCardPaymentCallback) => void;
};

export const PaymentContext = createContext<PaymentContextType>(
  emptyCartTotalDetails,
);
